const state = {
    // 로그인정보
    isLogined: false,
    uuid: null,
    luidx: null,
    cbidx: null,
    accessToken: null,
    refreshToken: null,

    //토큰만료정보
    tokenIat: null,
    tokenExp: null,
    refreshIat: null,
    refreshExp: null,

    //유저정보
    userInfo: null,
    allBranch: null,
    permissionInfo: null,

    //페이지의 상태, 상단메뉴바, 시스템바, 로딩창
    leftPageDrawer: false,
    pageStatus: null, 
    extraStatus: false, 
    loadingStatus: false,
    sysBarStatus: false,
    sysBarMessage: null,
    sysBarColor: null,
    sysBarInset: null,
    subNaviStatus: false, // sub navigation for detail page for pagination of function
    subNaviPage: null, // sub navigation page for a component name
    extraPageName: null,
    // approvalName: null, //결재선 상단 기안문서제목
    // electapFormIdx: null, //결재선 폼 idx

    // screen height control
    stateFullHeight: false,

    //기관기본 정보
    branchInfo: null,

    //기관 프로그램 버전
    programVersion: null,
    
    //기관로고 정보
    branchLogo: null,

    //기관직인
    branchOfficeSeal: null,

    //QRCode정보
    qrcode: '0',
    qrcodeLoginIdx: null,

    //인증번호정보
    authData: {
        mobileNo: null,
        authCodeSendIdx: null,
        authCode: null,
        userIdx: null,
        gubun: null,
    },

    //회원가입,휴대폰번호 변경 등 임시정보
    userTempInfo: { 
        userIdx: null,
        userName: null,
        birthday: null,
        password: null,
        oldMobileNo: null,
        mobileNo: null,
        residentRegistrationNumber: null
    },

    //기관정보 조회 리스트
    sidoCodes: null,
    customerBranchList: null,
    branchSearchStatus: false,

    //도로명 주소 조회 리스트
    searchRoadNameList: null,
    roadNameSearchStatus: false,

    //나의 서명정보
    mySign: null,

    //수급자 또는 보호자 서명정보
    thirdPersonSign: null,
    commonSign: null,

    /* page view type 
    {
        pageName: '', 
        name: router.component
        current: '{list|card}', 
        change: '{list|card}',
        default: '{list|card}'
    }, 
    */
    pageViewType: {
        name: null,
        current: null, 
        change: null,
        default: 'list'
    },

    //나의 근로계약
    myContracts: null,
    showPrintContractNo: null, // show print my contract form index no

    // //나의 급여정보
    // myPayslips: null,

    // 인증서 정보
    connectLTC: null,
    connectW4C: null,

    //보호자 서명접속정보
    defaultInfo: null,
    defaultBranch: null,

    //보호자 서명리스트
    guardianSignList: null,

    //기관 문자건수
    remainInfo: null,
    smsPhones: null,

    //sms발송페이지
    smsUserList: null,
    userFilter: null,
    
    //sms충전
    serviceInfo: null,

    //sms템플릿
    smsTemplete: null,

    //모든 주소검색(도로명, 구주소)
    allAddress: null,

    //국가공휴일
    commonHoliday: null,

    //오늘기준 영업일40일
    businessDay: null
};
  
export default state;
  


// WEBPACK FOOTER //
// ./src/store/default/state.js